import { useEffect, useState } from "react";

function prefersReducedMotion() {
  return typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
    : false;
}

/**
 * Milliseconds into a repeating animation of `loopMs`, for the "How it works" tablet screens.
 * Infinity (the finished frame, held still) when the viewer has turned motion off.
 */
export function useLoopTime(loopMs: number) {
  const [still] = useState(prefersReducedMotion);
  const [t, setT] = useState(0);
  useEffect(() => {
    if (still) return;
    const start = Date.now();
    const id = setInterval(() => setT((Date.now() - start) % loopMs), 50);
    return () => clearInterval(id);
  }, [still, loopMs]);
  return still ? Infinity : t;
}
